import { apiFetch } from './utils/api';
//const mock = require('./mocks/configuration.json');

export const configuration = {
  get: async (args) => {
    //return mock;

    const options = {
      method: 'GET',
      baseUrl: '/',
    };

    if (args && args.country) {
      options.country = args.country;
    }

    const url = '/configuration';

    const { body } = await apiFetch(url, {
      ...options,
    });

    if (body) {
      return body;
    } else {
      return { data: [] };
    }
  },
};
